// ===========================================
// Note Visibility Chip Component
// ===========================================

import { Chip } from '@mui/material';
import {
  Lock as LockIcon,
  Person as PersonIcon,
  School as SchoolIcon,
  Visibility as VisibilityIcon,
} from '@mui/icons-material';
import {
  NoteVisibility,
  getNoteVisibilityLabel,
  getNoteVisibilityColor,
} from '../../../api/notes.api';

interface Props {
  visibility: NoteVisibility;
}

/**
 * Visibility chip showing who can see the note
 */
export default function NoteVisibilityChip({ visibility }: Props) {
  const getIcon = () => {
    switch (visibility) {
      case 'TEACHERS_ONLY':
        return <LockIcon sx={{ fontSize: 14 }} />;
      case 'PARENTS':
        return <PersonIcon sx={{ fontSize: 14 }} />;
      case 'STUDENTS':
        return <SchoolIcon sx={{ fontSize: 14 }} />;
      default:
        return <VisibilityIcon sx={{ fontSize: 14 }} />;
    }
  };

  return (
    <Chip
      icon={getIcon()}
      label={getNoteVisibilityLabel(visibility)}
      size="small"
      color={getNoteVisibilityColor(visibility)}
      sx={{ height: 22, '& .MuiChip-label': { px: 1 } }}
    />
  );
}
